import { UseQueryResult } from '@tanstack/react-query';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';
import { useSession } from '../SessionProvider';
import {
  getCountries,
  getFilterList,
  getGeoshapeslist,
  getNavigationalStatuses,
  getRegions,
  getShipTypes,
} from './getFilterValues';
import { Filter } from '@ais-ui/websockets';

export const useGetCountries = (): UseQueryResult<string[] | null> => {
  const { olSession } = useSession();

  return useQuery(['getCountries'], () => {
    return getCountries(olSession);
  });
};

export const useGetShipTypes = (): UseQueryResult<string[] | null> => {
  const { olSession } = useSession();

  return useQuery(['getShipTypes'], () => {
    return getShipTypes(olSession);
  });
};

export const useGetNavigationalStatuses = (): UseQueryResult<
  string[] | null
> => {
  const { olSession } = useSession();

  return useQuery(['getNavigationalStatuses'], () => {
    return getNavigationalStatuses(olSession);
  });
};

export const useGetRegions = (): UseQueryResult<string[] | null> => {
  const { olSession } = useSession();

  return useQuery(['getRegions'], () => {
    return getRegions(olSession);
  });
};

export const useGetFilterList = (): UseQueryResult<Filter[] | null> => {
  const { olSession } = useSession();

  return useQuery(['getFilterList'], () => {
    return getFilterList(olSession);
  });
};

export const useGetGeoshapeslist = (): UseQueryResult<string[] | null> => {
  const { olSession } = useSession();

  return useQuery(['getGeoshapeslist'], () => {
    return getGeoshapeslist(olSession);
  });
};
